import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f314d7ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topban" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zhengque" }, "正确答案为ABCDE")
], -1))
const _hoisted_3 = { id: "about2" }
const _hoisted_4 = { class: "jieti1" }
const _hoisted_5 = { class: "jieti2" }
const _hoisted_6 = { class: "jieti3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dibu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dibu1" }, " 1.中华医学会皮肤性病学分会免疫学组.特应性皮炎的全程管理共识[J].中华皮肤科杂志,2023,56(1):5-15. "),
  /*#__PURE__*/_createElementVNode("div", { class: "dibu2" }, " 2.中国中西医结合学会皮肤性病专业委员会环境与职业性皮肤病学组,等.中华皮肤科杂志,2022,55(4)281-288. ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h20" }, null, -1))
const _hoisted_9 = { class: "bottomBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              width: "8.7067rem",
              height: "1.36rem",
              src: require('../assets/jieti1.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_image, {
              width: "8.0133rem",
              height: "3.64rem",
              src: require('../assets/jieti2.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: "2.64rem",
              src: require('../assets/jieti3.png')
            }, null, 8, ["src"])
          ]),
          _hoisted_7
        ]),
        _hoisted_8,
        _createTextVNode(" = "),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_van_image, {
            onClick: $options.baobiao,
            width: "6.1067rem",
            height: "1.1467rem",
            src: require('../assets/tszlfa.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}